import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export const WhoIsItForSection = () => {
  const forWho = ['Personas en un punto de quiebre que sienten que su vida actual ha terminado.', 'Buscadores espirituales cansados de teorías que quieren herramientas reales.', 'Almas experimentando una crisis de identidad o un despertar espiritual intenso.', 'Quien esté listo para dejar de ser una víctima de su historia y elija, finalmente, RENACER.'];
  const notForWho = ["Personas que buscan una 'píldora mágica' sin compromiso de introspección básica.", 'Escépticos rígidos que niegan que la conciencia afecta a la materia.'];
  return <section className="py-24 px-4 relative" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-203">
          {/* Para ti si... */}
          <FadeIn direction="right" data-id="element-204">
            <div className="p-8 md:p-10 rounded-2xl bg-gold-light/20 border border-gold/30 h-full" data-id="element-205">
              <h3 className="font-playfair text-2xl md:text-3xl font-bold text-gold-antique mb-8" data-id="element-206">
                Esto es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-207">
                {forWho.map((item, index) => <li key={index} className="flex gap-4" data-id="element-208">
                    <div className="flex-shrink-0 mt-1 bg-gold/15 p-1 rounded-full" data-id="element-209">
                      <Check className="text-gold-antique" size={18} data-id="element-210" />
                    </div>
                    <span className="text-brown-warm leading-relaxed" data-id="element-211">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* No es para ti si... */}
          <FadeIn direction="left" delay={0.2} data-id="element-212">
            <div className="p-8 md:p-10 rounded-2xl bg-parchment-dark border border-sand h-full" data-id="element-213">
              <h3 className="font-playfair text-2xl md:text-3xl font-bold text-brown-warm/60 mb-8" data-id="element-214">
                No es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-215">
                {notForWho.map((item, index) => <li key={index} className="flex gap-4" data-id="element-216">
                    <div className="flex-shrink-0 mt-1 bg-amber-accent/10 p-1 rounded-full" data-id="element-217">
                      <X className="text-amber-accent" size={18} data-id="element-218" />
                    </div>
                    <span className="text-brown-warm/60 leading-relaxed" data-id="element-219">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};